import { useToastContext } from "components/alert/ToastContext";
import BaseDataTableEdit from "components/dataTableableEdit/BaseDataTableEdit";
import Produto from "model/administracao/cadastro/produto/Produto";
import LoteItemEmprestimo from "model/patrimonio/LoteItemEmprestimo";
import EstoqueLote from "model/suprimentos/EstoqueLote";
import { Button } from "primereact/button";
import { Column, ColumnEditorOptions } from "primereact/column";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";
import { useEffect, useState } from "react";
import EmprestimoPatrimonioService from "service/patrimonio/EmprestimoPatrimonioService";

type Props = {
    visible: boolean;
    setVisible: (visible: boolean) => void;
    style?: React.CSSProperties | undefined;
    produto: Produto;
    inutilizavel: boolean;
    quantidade: number;
    lotes: LoteItemEmprestimo[];
    onConfirm: (lotes: LoteItemEmprestimo[]) => void;
    onCancel: () => void;
}

const emprestimoPatrimonioService = new EmprestimoPatrimonioService();

export default function SelecaoLotesEmprestimoModal(props: Props) {

    const [lotes, setLotes] = useState<LoteItemEmprestimo[]>(JSON.parse(JSON.stringify(props.lotes)));
    const [lotesDisponiveis, setLotesDisponiveis] = useState<LoteItemEmprestimo[]>([]);

    const { msgAlerta } = useToastContext();

    useEffect(() => {
        emprestimoPatrimonioService.lotesDisponiveis(props.produto).then((data) => {
            setLotesDisponiveis(data);
        }).catch((error) => {
            console.error(error);
        })
    }, [props.produto])

    useEffect(() => {
        setLotes(JSON.parse(JSON.stringify(props.lotes)));
    }, [props.lotes])

    const validar = () => {
        let soma = 0;
        let somaInutilizavel = 0;
        for (let i = 0; lotes.length > i; i++) {
            if (lotes[i].quantidadeEmprestada <= 0) {
                console.log(lotes[i])
                msgAlerta("Alerta", "Quantidade inválida para o lote " + lotes[i].estoqueLote?.lote);
                return false;
            }
            if (lotes[i].quantidadeInutilizavel > lotes[i].quantidadeEmprestada) {
                msgAlerta("Alerta", "Quantidade não pode ser maior que a quantidade emprestada");
                return false;
            }
            soma += lotes[i].quantidadeEmprestada;
            somaInutilizavel += lotes[i].quantidadeInutilizavel;
        }
        if(soma != props.quantidade) {
            msgAlerta("Alerta", "Quantidade não soma a quantidade emprestada ");
            return false;
        }
        if(props.inutilizavel) {
            if(somaInutilizavel <= 0){
                msgAlerta("Alerta", "Coloque uma quantidade inutilizável");
                return false
            }
        }

        return true;

    }

    const sugerirLotes = () => {
        if(props.quantidade <= 0) {
            msgAlerta("Quantidade igual a 0", "Não é possivel encontrar um lote");
        } else{
            emprestimoPatrimonioService.sugerirLotes(props.produto, props.quantidade).then(data=>{
                if(data.length>0){
                    console.log(data);
                    setLotes(data);
                }else{
                    msgAlerta("Quantidade indisponível", "Não foi possível encontrar lotes o suficiente que supram a quantidade necessária");
                }
            })
        }
    }

    const editorLote = (options: ColumnEditorOptions) => {
        return <Dropdown
            value={options.rowData["estoqueLote"]}
            style={{ width: '100%' }}
            options={lotesDisponiveis}
            disabled={props.inutilizavel}
            optionLabel="lote"
            itemTemplate={(item: EstoqueLote) => {
                return <div style={{ display: "flex", flexDirection: "column" }}>
                    <span><strong>Lote: </strong> {item.lote}</span>
                    <span><strong>Depósito:</strong> {item.deposito.nome}</span>
                    <span><strong>Quantidade:</strong> {item.quantidade.toLocaleString()}</span>
                </div>
            }}
            onChange={(e) => {
                options.rowData["estoqueLote"] = e.value;
                const lotesLocal = [...lotes];
                lotesLocal[options.rowIndex].estoqueLote = options.rowData["estoqueLote"];
                setLotes(lotesLocal);
            }}
        />
    }

    const editorQuantidade = (options: ColumnEditorOptions) => {
        return <InputNumber
            disabled={props.inutilizavel}
            value={options.rowData[options.field]}
            style={{ width: '100%' }}
            minFractionDigits={isKgouLt(props.produto.unidadeMedida) ? 1 : 0}
            maxFractionDigits={isKgouLt(props.produto.unidadeMedida) ? 8 : 0}
            maxLength={12}
            locale="pt-BR"
            useGrouping={false}
            onChange={(e) => {
                options.rowData[options.field] = e.value;
                const lotesLocal = [...lotes];
                lotesLocal[options.rowIndex] = options.rowData;
                setLotes(lotesLocal);
            }}
        />
    }

    const editorQuantidadeInutilizavel = (options: ColumnEditorOptions) => {
        return <InputNumber
            value={options.rowData[options.field]}
            style={{ width: '100%' }}
            minFractionDigits={isKgouLt(props.produto.unidadeMedida) ? 1 : 0}
            maxFractionDigits={isKgouLt(props.produto.unidadeMedida) ? 8 : 0}
            maxLength={12}
            locale="pt-BR"
            useGrouping={false}
            onChange={(e) => {
                options.rowData[options.field] = e.value;
                const lotesLocal = [...lotes];
                lotesLocal[options.rowIndex] = options.rowData;
                setLotes(lotesLocal);
            }}
        />
    }

    const isKgouLt = (unidadeMedida: string) => {
        return unidadeMedida == "KG" || unidadeMedida == "LT";
    }

    const confirmar = () => {
        if(validar()){
            props.onConfirm(lotes);
        }
    }

    return (
        <Dialog header="Seleção de Lotes" visible={props.visible} style={{ width: '50vw', ...props.style }} onHide={() => { props.onCancel() }}
            footer={<>
                <Button label="Cancelar" onClick={() => { props.onCancel() }} />
                <Button label="Confirmar" onClick={() => { confirmar() }} />
            </>}>
            <div style={{ display: "flex", flexDirection: "column", rowGap: 24 }}>
                <div>
                    <div>
                        <span style={{ fontWeight: "bold" }}>Produto: </span>
                        <span>{props.produto.codigo} - {props.produto.nome}</span>
                    </div>
                    <div style={{ marginTop: 8 }}>
                        <span style={{ fontWeight: "bold" }}>Quantidade: </span>
                        <span>{props.quantidade.toLocaleString()} {props.produto.unidadeMedida}</span>
                    </div>
                </div>

                <BaseDataTableEdit
                    tituloLista="Lotes"
                    getNewModel={() => new LoteItemEmprestimo()}
                    lista={lotes ? lotes : []}
                    setLista={(e) => setLotes(e as LoteItemEmprestimo[])}
                    showDelete={!props.inutilizavel}
                    addButtonDisabled={props.inutilizavel}
                    dataKey="key"
                    extraButtons={<Button label="Sugerir lotes" disabled={props.inutilizavel} style={{marginRight: 8}} onClick={()=>sugerirLotes()} />}
                >
                    <Column field="estoqueLote.lote" header="Lote" editor={(options) => editorLote(options)} />
                    <Column field="estoqueLote.deposito.nome" header="Depósito" />
                    <Column field="quantidadeEmprestada" header="Qtd. Emprestada" style={{ width: 150 }} editor={(options) => editorQuantidade(options)} />
                    {props.inutilizavel? <Column field="quantidadeInutilizavel" header="Qtd. Inutilizavel" style={{ width: 150 }} editor={(options) => editorQuantidadeInutilizavel(options)} /> : null}
                    
                </BaseDataTableEdit>
            </div>
        </Dialog>
    )
}